<template>
  <card-with-header-and-footer-component :loading="address.loading">
    <template v-slot:header>
      <h3 class="text-lg font-semibold leading-5 text-gray-900 sm:truncate">{{ $t("customization.location") }}</h3>
    </template>

    <div class="grid grid-cols-1 sm:grid-cols-4 gap-6">
      <div class="sm:col-span-4">
        <label for="address_line_1" class="block text-sm font-medium text-gray-700">{{ $t("customization.address_line_1") }}</label>
        <div class="mt-1">
          <input type="text" v-model="address.request.address_line_1" id="address_line_1" class="shadow-sm focus:ring-bpblue focus:border-bpblue block w-full sm:text-sm border-gray-300 rounded-md" placeholder="" aria-describedby="email-description">
        </div>
      </div>
      <div class="sm:col-span-4">
        <label for="address_line_2" class="block text-sm font-medium text-gray-700">{{ $t("customization.address_line_2") }}</label>
        <div class="mt-1">
          <input type="text" v-model="address.request.address_line_2" id="address_line_2" class="shadow-sm focus:ring-bpblue focus:border-bpblue block w-full sm:text-sm border-gray-300 rounded-md" placeholder="" aria-describedby="email-description">
        </div>
      </div>
      <div class="sm:col-span-2">
        <label for="address_postal_code" class="block text-sm font-medium text-gray-700">{{ $t("customization.postalcode") }}</label>
        <div class="mt-1">
          <input type="text" v-model="address.request.postal_code" id="address_postal_code" class="shadow-sm focus:ring-bpblue focus:border-bpblue block w-full sm:text-sm border-gray-300 rounded-md" placeholder="" aria-describedby="email-description">
        </div>
      </div>
      <div class="sm:col-span-2">
        <label for="address_city" class="block text-sm font-medium text-gray-700">{{ $t("customization.city") }}</label>
        <div class="mt-1">
          <input type="text" v-model="address.request.city" id="address_city" class="shadow-sm focus:ring-bpblue focus:border-bpblue block w-full sm:text-sm border-gray-300 rounded-md" placeholder="" aria-describedby="email-description">
        </div>
      </div>
      <div class="sm:col-span-2">
        <label for="address_state" class="block text-sm font-medium text-gray-700">{{ $t("customization.province") }}</label>
        <div class="mt-1">
          <input type="text" v-model="address.request.state" id="address_state" class="shadow-sm focus:ring-bpblue focus:border-ibpblue block w-full sm:text-sm border-gray-300 rounded-md" placeholder="" aria-describedby="email-description">
        </div>
      </div>
      <div class="sm:col-span-2">
        <label for="address_country" class="block text-sm font-medium text-gray-700">{{ $t("customization.country") }}</label>
        <div class="mt-1">
          <input type="text" v-model="address.request.country" id="address_country" class="shadow-sm focus:ring-bpblue focus:border-bpblue block w-full sm:text-sm border-gray-300 rounded-md" placeholder="" aria-describedby="email-description">
        </div>
      </div>
      <div class="sm:col-span-2">
        <label for="fiscal_fullname" class="block text-sm font-medium text-gray-700">{{ $t("customization.company_name") }}</label>
        <div class="mt-1">
          <input type="text" v-model="address.request.fiscal_fullname" id="fiscal_fullname" class="shadow-sm focus:ring-bpblue focus:border-bpblue block w-full sm:text-sm border-gray-300 rounded-md" placeholder="" aria-describedby="email-description">
        </div>
      </div>
      <div class="sm:col-span-2">
        <label for="vat_id" class="block text-sm font-medium text-gray-700">{{ $t("customization.nif_cif") }}</label>
        <div class="mt-1">
          <input type="text" v-model="address.request.vat_id" id="vat_id" class="shadow-sm focus:ring-bpblue focus:border-bpblue block w-full sm:text-sm border-gray-300 rounded-md" placeholder="" aria-describedby="email-description">
        </div>
      </div>
    </div>

    <template v-slot:footer>
      <button type="button" v-on:click="getAcademyContact" :disabled="address.loading" class="mr-2 inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bpblue">
        {{ $t("general.cancel") }}
      </button>

      <button type="button" v-on:click="setAcademyContact" :disabled="address.loading" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-bpblue hover:bg-bpbluedeep focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bpblue">
        {{ $t("general.save") }}
      </button>
    </template>
  </card-with-header-and-footer-component>
</template>

<script>
import CardWithHeaderAndFooterComponent from "@/components/panels/CardWithHeaderAndFooterComponent";
import ContactService from "@/services/academy/ContactService";
import NotificationService from "@/services/notification/NotificationService";
import {useAuthUserStore} from "@/stores/auth";

export default {
  name: "FiscalDataComponent",
  components: {
    CardWithHeaderAndFooterComponent
  },
  data() {
    return {
      address: {
        loading: false,
        request: {
          address_line_1: '',
          address_line_2: '',
          postal_code: '',
          city: '',
          state: '',
          country: '',
          fiscal_fullname: '',
          vat_id: ''
        }
      },
    }
  },
  setup () {

    const authUserStore = useAuthUserStore()

    return {
      authUserStore
    }
  },
  mounted() {
    this.getAcademyContact();
  },
  methods: {
    getAcademyContact() {
      let academy_uuid = this.authUserStore.user.academy.uuid;
      this.address.loading = true;

      ContactService.index(academy_uuid)
          .then((response) => {
            console.log("Se han obtenido los datos de contacto correctamente", response)
            this.address.request = response.data.address
          })
          .catch((response) => {
            console.log("Error obteniendo la dirección", response)
            NotificationService.showNotification("Ha ocurrido un error inesperado", "error")
          })
          .finally(() => {
            this.address.loading = false
          })
    },
    setAcademyContact() {
      let academy_uuid = this.authUserStore.user.academy.uuid;
      this.address.loading = true;

      ContactService.update(academy_uuid, this.address.request)
          .then((response) => {
            console.log("Se han obtenido los datos de contacto correctamente", response)
            NotificationService.showNotification("Se ha almacenado la petición correctamente", "success")
          })
          .catch((error) => {
            console.log("Error guardando las RRSS", error.response)
            if (error.response.data.errors)
            {
              error.response.data.errors.forEach( (error) => {
                NotificationService.showNotification(error, "error")
              })
            }
            else
            {
              NotificationService.showNotification("Ha ocurrido un error inesperado", "error")
            }
          })
          .finally(() => {
            this.address.loading = false
          })
    },
  }
}
</script>

<style scoped>

</style>
